import styled from 'styled-components';
import { media } from '@/styles/Qtheme';

export const HeroContainer = styled.section`
  position: relative;
  width: 100%;
  height: 618px;
  background: #2b2f73;
  overflow: hidden;
`;

export const Background = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #2b2f73;
  z-index: 0;
`;

export const PlanetsBg = styled.div`
  position: absolute;
  top: 50%;
  left: calc(50% + 34.5px);
  transform: translate(-50%, -50%);
  width: 1851px;
  height: 603px;
  z-index: 1;
  opacity: 0.8;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const AstronautIllustration = styled.div`
  position: absolute;
  top: calc(50% + 64.5px);
  left: calc(50% + 326.69px);
  transform: translate(-50%, -50%);
  width: 472.191px;
  height: 413.201px;
  z-index: 2;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const RocketIcon = styled.div`
  position: absolute;
  top: calc(50% + -129.5px);
  left: calc(50% + 223px);
  transform: translate(-50%, -50%);
  width: 58px;
  height: 91px;
  z-index: 3;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const ContentWrapper = styled.div`
  position: relative;
  max-width: 1920px;
  margin: 0 auto;
  padding: 0 379px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  z-index: 3;
  
  @media ${media.mobile} {
    padding: 0 20px;
  }
`;

export const LeftSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-bottom: 40px;
`;

export const Title = styled.h1`
  font-family: 'Rubik', sans-serif;
  font-weight: 500;
  font-size: 50px;
  line-height: normal;
  color: #ffffff;
  margin: 0;
`;

export const Description = styled.p`
  font-family: 'Rubik', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
  width: 482px;
  
  @media ${media.mobile} {
    width: 100%;
  }
`;

export const TotalRewards = styled.p`
  font-family: 'Rubik', sans-serif;
  font-weight: 500;
  font-size: 20px;
  line-height: normal;
  color: #ffffff;
  margin: 0;
  text-transform: uppercase;
`;

export const RewardsHighlight = styled.span`
  color: #6fc9d9;
  text-transform: uppercase;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  
  @media ${media.mobile} {
    flex-direction: column;
    width: 100%;
  }
`;

export const PrimaryButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  padding: 12px 21px;
  border-radius: 30px;
  background: linear-gradient(135deg, #007aff 0%, #0051d5 100%);
  border: none;
  color: #ffffff;
  font-family: 'Rubik', sans-serif;
  font-weight: 500;
  font-size: 16px;
  cursor: pointer;
  height: 50px;
  min-width: 144px;
  
  &:hover {
    opacity: 0.9;
  }
`;

export const SecondaryButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 11px 21px;
  border-radius: 30px;
  background: transparent;
  border: 1.5px solid rgba(255, 255, 255, 0.3);
  color: #ffffff;
  font-family: 'Rubik', sans-serif;
  font-weight: 500;
  font-size: 16px;
  cursor: pointer;
  height: 50px;
  min-width: 124px;
  
  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`;

export const CheckInIcon = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const MyRewardsIcon = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const ShareIcon = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

// Legacy styles for backward compatibility
export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 552px;

  @media ${media.desktop} {
    height: 452px;
  }

  @media ${media.mobile} {
    height: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    gap: 20px;
  }
`;

export const RightSectionWrapper = styled.div`
  height: 492px;
  position: relative;

  display: flex;
  align-items: center;
  justify-content: center;

  @media ${media.desktop} {
    height: 442px;
  }
`;

export const RightSection = styled.div`
  overflow: hidden;
  width: 524px;
  display: flex;
  align-items: center;
  height: 100%;
  position: relative;

  @media ${media.desktop} {
    width: 424px;
  }
`;

export const RightSectionImage = styled.img`
  position: absolute;
  top: 60px;
  width: 100%;
  object-fit: cover;
`;

export const RightSectionRotatedImage = styled.img`
  position: absolute;
  bottom: -270px;
  width: 100%;
  object-fit: cover;
  transform: rotate(180deg);
  z-index: -1;
  filter: blur(12px);
  opacity: 0.3;

  @media ${media.desktop} {
    bottom: -170px;
  }
`;

export const CoinCenter = styled.img`
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  filter: drop-shadow(0px 10px 50px rgba(0, 0, 0, 0.1));
`;

export const CoinLeft = styled.img`
  position: absolute;
  top: 100px;
  left: 40px;
  filter: drop-shadow(0px 10px 50px rgba(0, 0, 0, 0.15));
`;

export const CoinRight = styled.img`
  position: absolute;
  top: 110px;
  right: 40px;
  filter: drop-shadow(0px 10px 50px rgba(0, 0, 0, 0.15));
`;

export const RightSectionLayout = styled.img`
  position: absolute;
  width: 700px;
  top: -30px;
  left: -80px;
  object-fit: cover;
  z-index: -1;

  @media ${media.desktop} {
    width: 500px;
    top: 0;
    left: -5px;
  }
`;

export const TitlePrimary = styled.span`
  color: #007aff;
`;

export const JoinButton = styled.button`
  width: 190px;
  height: 40px;
  background-color: ${({ theme }) => theme.COLORS.tabMenuActive};
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  font-family: 'Pretendard', sans-serif !important;
  border-radius: 4px;
`;

export const JoinButtonMobile = styled.button`
  width: 190px;
  height: 40px;
  background-color: ${({ theme }) => theme.COLORS.tabMenuActive};
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  font-family: 'Pretendard', sans-serif !important;
  border-radius: 4px;

  position: absolute;
  bottom: 0;
`;
